import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'datetime-intervalo-vistoria-final',
  templateUrl: './datetime-intervalo-vistoria-final.component.html',
  styleUrls: ['./datetime-intervalo-vistoria-final.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class DatetimeIntervaloVistoriaFinalComponent implements OnInit {
  
  private formGroup: FormGroup;
  now: string = new Date().toISOString().split('T')[0];
  
  constructor(
    private _controlContainer: ControlContainer
  ) { }
  
  ngOnInit() {  
  }
  
  async ngAfterViewInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this._validators();
  }
  
  private _validators() {
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.formGroup.get('dtVistoriaFinal').setValidators([DataValidator.max(date)]);
    this.formGroup.get('dtVistoriaFinal').updateValueAndValidity();
  }
}
